import React, { useContext } from 'react';
import { string, shape, arrayOf } from 'prop-types';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { SizeGuideHeader } from '../size-guide-header/size-guide-header';
import { SizeGuideDropdown } from '../size-guide-dropdown/size-guide-dropdown';
import { SizeGuideTable } from '../size-guide-table/size-guide-table';

export const SizeGuideOverlayContent = (props) => {
  const {
    sizeGuideResponse = {},
    productType,
    channelFromMock
  } = props;

  const {
    channel = 'desktop'
  } = useContext(ExperienceContext) || {};

  const isMobile = channelFromMock === 'mobile' || channel === 'mobile';
  const { collectionName } = sizeGuideResponse;

  return (
    <div className="size-guide">
      {collectionName && <SizeGuideHeader collectionName={collectionName} isMobile={isMobile} />}
      {isMobile ? (
        <SizeGuideDropdown productType={productType} sizeGuideResponse={sizeGuideResponse} />
      ) : (
        <SizeGuideTable sizeGuideResponse={sizeGuideResponse} />
      )}
    </div>
  );
};

SizeGuideOverlayContent.displayName = 'SizeGuideOverlayContent';

SizeGuideOverlayContent.propTypes = {
  channelFromMock: string,
  sizeGuideResponse: shape({
    attributeGroups: arrayOf(shape({}))
  }).isRequired,
  productType: string
};

SizeGuideOverlayContent.defaultProps = {
  channelFromMock: null,
  productType: null
};
